import * as R from 'ramda';
import React, { memo } from 'react';
// components
import { TabsMui } from '../../../../components/tabs-mui';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
//////////////////////////////////////////////////

// NOTE: check R.gt(leftActiveTab, 2) and R.subtract(leftActiveTab, 3) in maintenance feature if add new tab
const getTabs = (activeTab, invoices, errors = {}) => {
  const defaultTabs = [
    {
      value: 0,
      withCount: R.equals(activeTab, 0),
      text: G.getWindowLocale('titles:service', 'Service'),
      withError: G.isNotNilAndNotEmpty(R.omit([GC.FIELD_INVOICES, GC.FIELD_SERVICE_VENDOR_GUID], errors)),
    },
    {
      value: 1,
      withCount: R.equals(activeTab, 1),
      text: G.getWindowLocale('titles:vendor', 'Vendor'),
      withError: G.isNotNilAndNotEmpty(R.prop(GC.FIELD_SERVICE_VENDOR_GUID, errors)),
    },
    {
      value: 2,
      withCount: R.equals(activeTab, 2),
      text: G.getWindowLocale('titles:estimates', 'Estimates'),
    },
  ];

  const invoiceTabs = invoices.map((invoice, index) => ({
    value: R.add(index, 3),
    withCount: R.add(index, 3),
    text: `${G.getWindowLocale('titles:invoice', 'Invoice')} ${R.inc(index)}`,
    withError: G.isNotNilAndNotEmpty(R.path([GC.FIELD_INVOICES, index], errors)),
  }));

  return R.concat(defaultTabs, invoiceTabs);
};

const LeftTabs = (props) => {
  const {
    errors,
    invoices,
    leftActiveTab,
    setLeftActiveTab,
  } = props;

  return (
    <TabsMui
      activeTab={leftActiveTab}
      setActiveTab={setLeftActiveTab}
      tabStyles={GC.COMMON_MUI_TAB_STYLES}
      tabsProps={{ variant: 'scrollable' }}
      tabs={getTabs(leftActiveTab, invoices, errors)}
      tabsStyles={{ ...GC.COMMON_MUI_TABS_STYLES, width: null, m: '15px' }}
    />
  );
};

export default memo(LeftTabs);
